"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ChangeModuleItemsUtils {
}
ChangeModuleItemsUtils.changeModule = (moduleId, modules) => {
    {
        const newModules = modules.map((module) => {
            if (module.id === moduleId) {
                const newPages = module.pages.map((page) => {
                    return { ...page, isChecked: !module.isChecked };
                });
                return {
                    ...module,
                    isChecked: !module.isChecked,
                    pages: newPages
                };
            }
            return { ...module };
        });
        return newModules;
    }
};
ChangeModuleItemsUtils.changeModulePage = (moduleId, pageId, modules) => {
    {
        const newModules = modules.map((module) => {
            if (module.id === moduleId) {
                const newPages = module.pages.map((page) => {
                    if (page.id === pageId) {
                        return {
                            ...page,
                            isChecked: !page.isChecked
                        };
                    }
                    return { ...page };
                });
                const isModuleChecked = newPages.every((page) => page.isChecked);
                return { ...module, isChecked: isModuleChecked, pages: newPages };
            }
            return { ...module };
        });
        return newModules;
    }
};
exports.default = ChangeModuleItemsUtils;
